import { Link } from "react-router-dom";

export default function GradientCustom({ text, href = "", color }) {
  const colorMap = {
    blue: "#2F576D",
    yellow: "#5C511D",
    green: "#2F6D3C",
    red: "#501717",
  };
  const selected = colorMap[color];
  return (
    <Link
      to={href}
      className={`w-full rounded-full bg-zi-gradient-button-${color} text-zi-text-dark flex items-center justify-center py-2.5 outline-none hocus:ring-offset-1 hocus:ring-1`}
      style={{ "--tw-ring-color": selected }}
    >
      {text}
    </Link>
  );
}
